import React, { Component, HTMLProps } from 'react';
import Icon from '../../icons/Icon';

class CustomPasswordInput extends Component<Props, State> {
  public state = new State();

  public render() {
    const { className, inputSize = 'sm', ...rest } = this.props;
    const { type } = this.state;
    return (
      <div className={`flex ${this.getSize()}  w-full relative group `}>
        <input
          autoComplete='new-password'
          type={type}
          className={
            'w-full rounded-[4px] disabled:opacity-50 focus:outline-none text-sm  focus:formica-shadow  outline-none! indent-3 text-f-input-text border-[1px] border-f-black-5 bg-white focus:border-f-purple hover:border-f-purple disabled:cursor-not-allowed ' +
            className
          }
          {...rest}
        />
        <span onClick={this.onChangeType} className={'absolute cursor-pointer right-2 top-0 h-full formica-input flex items-center '}>
          <Icon className={'group-hover:text-f-purple text-f-black-3 group-focus-within:text-f-purple'} icon={'eye'} size={16} />
        </span>
      </div>
    );
  }

  private onChangeType = () => {
    const { type } = this.state;
    if (type == 'password') this.setState({ type: 'text' });
    else this.setState({ type: 'password' });
  };

  private getSize = () => {
    const { inputSize = 'md' } = this.props;
    switch (inputSize) {
      case 'sm':
        return 'h-[32px] min-h-[32px]';
      case 'md':
        return 'h-[34px] min-h-[34px]';
      case 'lg':
        return 'h-[40px] min-h-[40px]';
      default:
        return 'h-[34px] min-h-[34px]';
    }
  };
}

class State {
  type: 'password' | 'text' = 'password';
}

interface Props extends HTMLProps<HTMLInputElement> {
  inputSize?: 'sm' | 'md' | 'lg';
}

export default CustomPasswordInput;
